"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BgLocalFetchDistrictNamesComponentParameters = void 0;
exports.BgLocalFetchDistrictNamesComponentParameters = [
    {
        id: 'states',
        label: 'States',
        description: 'Input Param - List of states for which district names are to be fetched',
        type: 'list',
        paramType: 'STRING_ARRAY',
        required: true,
    },
    {
        id: 'options',
        label: 'State-Districts Mapping',
        description: 'Input Param (Optional) - Mapping from states to their districts',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'districts',
        label: 'Districts',
        description: 'Output Param - List of districts fetched for the given states',
        type: 'output',
        paramType: 'STRING_ARRAY',
        required: true,
    },
];
//# sourceMappingURL=BgLocalFetchDistrictNamesComponent.js.map